import {ApplicationRef, Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {Settings} from '@orga-app/settings';
import {IonRefresher, Platform} from '@ionic/angular';
import {getAktionen} from './aktionen.reducer';
import {PageStateResetAction, ToggleAktionAction} from './aktionen.actions.ui';
import {AktionUi} from './aktionen.model.ui';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {SafeUrl} from '@angular/platform-browser';
import { NotificationService } from '@orga-app/providers/notification.service';
import { WindowRefService } from '@orga-app/providers/window.service';
import {Veranstaltung, VeranstaltungDetail} from '../../../../clients/veranstaltungen';
import {getAktuelleVeranstaltung, getVeranstaltungDeckblatt, getVeranstaltungDeckblattFehler, getVeranstaltungDeckblattLaden, GlobalAppState} from '../../app-state/app-state.reducer';
import {PageLoadDataAction} from '../../app-state/actions/veranstaltung.actions';
import {ItemWrapper} from '../../../shared/sopi-list/sopi-list.model';

@Component({
    selector: 'app-aktionen',
    templateUrl: './aktionen.page.html',
})
export class AktionenPage implements OnInit {
    @ViewChild(IonRefresher, { static: false})
    refresher: IonRefresher;
    public themeDefault$: Observable<Settings>;
    public settings$: Observable<Settings>;
    public aktuelleVeranstaltung$: Observable<Veranstaltung>;
    public veranstaltungDeckblatt$: Observable<VeranstaltungDetail>;
    public veranstaltungDeckblattLaden$: Observable<boolean>;
    public veranstaltungDeckblattFehler$: Observable<boolean>;
    aktionen$: Observable<Array<AktionUi>>;
    private aiName = 'AktionenPage';
    private windowLocal: Window;
    private aktuelleVeranstaltungId: string;
    logoHeaderSVG$: Observable<SafeUrl>;

    constructor(public platform: Platform,
                private notificationService: NotificationService,
                private windowRefService: WindowRefService,
                private storeVeranstaltung: Store<GlobalAppState>,
                private settingsProvider: SettingsProvider,
                private store: Store<any>,
                private appRef: ApplicationRef) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.settingsProvider.getActiveTheme();
    }

    ngOnInit() {
        this.windowLocal = this.windowRefService.nativeWindow;
        this.aktuelleVeranstaltung$ = this.storeVeranstaltung.pipe(select(getAktuelleVeranstaltung));
        this.aktuelleVeranstaltung$.subscribe((aktuelleVeranstaltung) => {
            if (aktuelleVeranstaltung != null) {
                this.aktuelleVeranstaltungId = aktuelleVeranstaltung.veranstaltung_id;
            }
        });
        this.veranstaltungDeckblatt$ = this.storeVeranstaltung.pipe(select(getVeranstaltungDeckblatt));
        this.veranstaltungDeckblattLaden$ = this.storeVeranstaltung.pipe(select(getVeranstaltungDeckblattLaden));
        this.veranstaltungDeckblattFehler$ = this.storeVeranstaltung.pipe(select(getVeranstaltungDeckblattFehler));
        this.aktionen$ = this.storeVeranstaltung.pipe(select(getAktionen));

        // this.veranstaltungDeckblattLaden$.subscribe(() => {
        //     this.appRef.tick();
        // });
        //
        // this.veranstaltungDeckblatt$.subscribe(x => {
        //     this.appRef.tick();
        // });
    }

    ionViewWillEnter() {
        this.viewWillEnterPage().then();
    }

    async viewWillEnterPage() {
        this.store.dispatch(new PageStateResetAction());
        await this.aktionenErneutLaden();
        // await this.storeVeranstaltung.dispatch(new PageLoadDataAction());
    }

    ionViewDidEnter() {
      if (this.refresher !== undefined) {
        this.refresher.disabled = false;
      }
    }

    ionViewWillLeave() {
      if (this.refresher !== undefined) {
        this.refresher.disabled = true;
      }
    }

    async pageAktualisieren(event) {
        await this.aktionenErneutLaden();
        // await event.target.complete();
        setTimeout(function () {
            event.target.complete();
        }.bind(this), 200);
    }

    async aktionenErneutLaden() {
        // Deckblatt erneut laden
        this.storeVeranstaltung.dispatch(new PageLoadDataAction());
    }

    async toggleAktion(aktion: AktionUi) {
        this.storeVeranstaltung.dispatch(new ToggleAktionAction(aktion.aktion_id));
    }

    trackByAktion(index, item: AktionUi) {
        return item.aktion_id;
    }
}
